import React from "react";
import { Navigate, Route, Routes as RouterRoutes } from "react-router-dom";
import Header from "src/components/header/header";
import Integrations from "src/scenes/integrations";
import Upgrade from "src/scenes/upgrade";
import Invite from "src/scenes/invite";
import IntegrationResult from "src/scenes/integrations/integration-result";
import PermissionsGitlab from "src/scenes/integrations/permissions/gitlab";
import PermissionsGitlabSelfHosted from "src/scenes/integrations/permissions/gitlab-self-hosted";
import UpgradeInquiry from "src/scenes/upgrade/inquiry";
import Profile from "src/scenes/profile";
import ProtectedRoute from "src/services/protected-route";
import Dashboard from "src/scenes/dashboard";
import Checkout from "src/scenes/upgrade/checkout";
import Subscription from "src/scenes/subscription";
import NotFound from "src/scenes/errors/not-found";
import LogInScreen from "src/scenes/log-in";
import Error from "src/scenes/errors/error";
import GitlabOauth from "src/scenes/integrations/gitlab-oauth";
import JiraOauth from "src/scenes/integrations/jira-oauth";
import SlackOauth from "src/scenes/integrations/slack-oauth";
import Teams from "src/scenes/teams/teams";
import Team from "src/scenes/teams/team/team";
import TeamDashboard from "src/scenes/teams/dashboard";
import TeamsIndex from "src/scenes/teams";
import Analytics from "src/scenes/dashboard/analytics";
import RedirectToInsights from "src/scenes/teams/dashboard/redirect-to-overview";
import TeamIndex from "src/scenes/teams/team";
import GithubOauth from "src/scenes/integrations/github-oauth";
import PermissionsGithub from "src/scenes/integrations/permissions/github";
import PermissionsSlack from "src/scenes/integrations/permissions/slack";
import Achievements from "src/scenes/achievements";
import Roadblock from "src/scenes/roadblock";
import MissionsHistoryTeams from "src/scenes/teams/team/missions-history";
import { ActiveDateProvider } from "src/scenes/dashboard/date-provider";
import MissionsHistory from "src/scenes/missions-history";
import PersonalProfile from "src/scenes/personal-profile";
import SetupWizard from "src/scenes/setup-wizard";
import PublicPersonalProfile from "src/scenes/personal-profile-public";
import HeaderGuest from "src/components/header/header-guest";
import inIframe from "src/components/in-iframe";
import DeveloperPortal from "src/scenes/developer-portal";
import MissionsPersonal from "src/scenes/missions-personal";
import MissionsTeams from "src/scenes/missions-teams";
import WeeklySummary from "src/scenes/summary";
import CaseAnalysis from "src/scenes/case-analysis";
import CausationAnalysis from "src/scenes/causal-analysis";
import SettingsGitlab from "src/scenes/integrations/settings/gitlab";
import SettingsGithub from "src/scenes/integrations/settings/github";
import SettingsGitlabSelfHosted from "src/scenes/integrations/settings/gitlab-self-hosted";
import SettingsMicrosoft from "src/scenes/integrations/settings/microsoft";
import SettingsAzure from "src/scenes/integrations/settings/azure";
import SettingsSlack from "src/scenes/integrations/settings/slack";
import SettingsJira from "src/scenes/integrations/settings/jira";
import SettingsGoogle from "src/scenes/integrations/settings/google";
import { ActiveIntegrationsProvider } from "src/scenes/dashboard/active-integrations-provider";
import SettingsNotion from "src/scenes/integrations/settings/notion";
import TeamInsights from "src/scenes/teams/dashboard/insights";
import Insights from "src/scenes/dashboard/insights";
import Overview from "src/scenes/overview";
import GithubAppOauth from "src/scenes/integrations/github-app-oauth";
import PermissionsGithubApp from "src/scenes/integrations/permissions/github-app";
import SettingsGithubApp from "src/scenes/integrations/settings/github-app";
import SettingsJiraOrg from "src/scenes/integrations/settings/jira-org";
import SettingsNotionOrg from "src/scenes/integrations/settings/notion-org";
import PermissionsNotionOrg from "src/scenes/integrations/permissions/notion-org";
import SettingsGitlabSelfHostedOrg from "src/scenes/integrations/settings/gitlab-self-hosted-org";
import PermissionsGitlabSelfHostedOrg from "src/scenes/integrations/permissions/gitlab-self-hosted-org";
import RepoView from "src/scenes/per-repo";
import SetupWizardSnackbar from "src/components/setup-wizard-notification";
import PermissionsMicrosoftOrg from "src/scenes/integrations/permissions/microsoft-org";
import PermissionsAzureOrg from "src/scenes/integrations/permissions/azure-org";
import SettingsMicrosoftOrg from "src/scenes/integrations/settings/microsoft-org";
import SettingsAzureOrg from "src/scenes/integrations/settings/azure-org";
import DeploymentsConfigAll from "src/scenes/deployments-config-all";
import NavigationPage from "src/scenes/navigation";
import { TemplateViewEditProvider } from "src/components/providers/template-view-edit-provider";
import { TemplateDrawerProvider } from "src/components/providers/template-drawer-provider";
import IndexesSettings from "src/scenes/indexes-settings";
import TemplatesDetails from "src/scenes/templates-details";
import LogInScreenUsername from "src/scenes/log-in/username";
import TeamAnalytics from "./teams/dashboard/analytics";
import PermissionsGoogle from "./integrations/permissions/google";
import PermissionsJira from "./integrations/permissions/jira";
import PermissionsNotion from "./integrations/permissions/notion";
import PermissionsMicrosoft from "./integrations/permissions/microsoft";
import PermissionsAzure from "./integrations/permissions/azure";
import GoogleOauth from "./integrations/google-oauth";
import NotionOauth from "./integrations/notion-oauth";
import EmailValidation from "./email-validation";
import Notifications from "./notifications";
import Changelog from "./changelog";
import MicrosoftOauth from "./integrations/microsoft-oauth";
import AzureOauth from "./integrations/azure-oauth";
import NotionSetup from "./integrations/notion-setup";
import PermissionsJiraOrg from "./integrations/permissions/jira-org";
import OverviewMain from "./overview/overview-main";
import OverviewAnalytics from "./overview/overview-analytics";
import PermissionsGoogleOrg from "./integrations/permissions/google-org";
import SettingsGoogleOrg from "./integrations/settings/google-org";
import Main from "../main";

const Routes = ({ handleSetDark }) => {
    return (
        <RouterRoutes>
            <Route path="/login" element={<LogInScreen />} />
            <Route path="/login-username" element={<LogInScreenUsername />} />
            <Route
                path="/personal-profile/:handle"
                element={
                    <>
                        {!inIframe() && <HeaderGuest />}
                        <Main>
                            <PublicPersonalProfile />
                        </Main>
                    </>
                }
            />
            <Route
                path="/roadblock"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} isDisemboweled />
                        <Main>
                            <Roadblock />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/email-validation"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} isDisemboweled />
                        <Main>
                            <EmailValidation />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/navigation"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <NavigationPage />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/templates-details"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <TemplatesDetails />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/gitlab/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <GitlabOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/github/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <GithubOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/github-app/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <GithubAppOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/slack/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <SlackOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/google/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <GoogleOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/jira/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <JiraOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/notion/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <NotionOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/setup/notion"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <NotionSetup />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/microsoft/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <MicrosoftOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/azure/oauth"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <AzureOauth />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/:response/:integrationName"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <IntegrationResult />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <Integrations />
                                <SetupWizardSnackbar />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/gitlab"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsGitlab />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/gitlab-self-hosted"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsGitlabSelfHosted />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/gitlab-self-hosted-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsGitlabSelfHostedOrg />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/github"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsGithub />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/github-app"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsGithubApp />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/jira-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsJiraOrg />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/notion-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsNotionOrg />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/slack"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsSlack />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/google"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsGoogle />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/google-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsGoogleOrg />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/jira"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsJira />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/notion"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsNotion />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/microsoft"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsMicrosoft />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/azure"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsAzure />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/microsoft-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsMicrosoftOrg />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/permissions/azure-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PermissionsAzureOrg />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/gitlab"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsGitlab />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/gitlab-self-hosted"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsGitlabSelfHosted />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/gitlab-self-hosted-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsGitlabSelfHostedOrg />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/github"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsGithub />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/microsoft-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsMicrosoftOrg />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/azure-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsAzureOrg />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/github-app"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsGithubApp />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/jira-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsJiraOrg />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/notion-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsNotionOrg />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/microsoft"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsMicrosoft />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/azure"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsAzure />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/slack"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsSlack />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/jira"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsJira />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/notion"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsNotion />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/google"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsGoogle />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/google-org"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsGoogleOrg />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/integrations/settings/notion"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveIntegrationsProvider>
                                <SettingsNotion />
                            </ActiveIntegrationsProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/upgrade/checkout"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Checkout />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/upgrade/checkout/*"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Checkout />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/upgrade/inquiry"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <UpgradeInquiry />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/upgrade"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Upgrade />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/subscription"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Subscription />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/causal"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <CausationAnalysis />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/overview"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveDateProvider>
                                <ActiveIntegrationsProvider>
                                    <Overview />
                                </ActiveIntegrationsProvider>
                            </ActiveDateProvider>
                        </Main>
                    </ProtectedRoute>
                }
            >
                <Route
                    path=""
                    element={
                        <TemplateViewEditProvider viewType="exec">
                            <TemplateDrawerProvider>
                                <OverviewMain />
                            </TemplateDrawerProvider>
                        </TemplateViewEditProvider>
                    }
                />
                <Route
                    path="details"
                    element={
                        <TemplateViewEditProvider viewType="exec-ts">
                            <TemplateDrawerProvider>
                                <OverviewAnalytics />
                            </TemplateDrawerProvider>
                        </TemplateViewEditProvider>
                    }
                />
            </Route>
            <Route
                path="/invite"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Invite />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/profile"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Profile />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/summary"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <WeeklySummary />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/case-analysis"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <CaseAnalysis />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/deployments-config-all"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <DeploymentsConfigAll />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/personal-profile"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <PersonalProfile />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/setup-wizard"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <SetupWizard />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/developer-portal"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <DeveloperPortal />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/achievements"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Achievements />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/notifications"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Notifications />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/changelog"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Changelog />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="missions-history"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <MissionsHistory />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="missions-personal"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <MissionsPersonal />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="missions-teams"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <MissionsTeams />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="repo-view"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveDateProvider>
                                <TemplateViewEditProvider viewType="repoViews">
                                    <TemplateDrawerProvider>
                                        <RepoView />
                                        <SetupWizardSnackbar />
                                    </TemplateDrawerProvider>
                                </TemplateViewEditProvider>
                            </ActiveDateProvider>
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="indexes-settings"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <IndexesSettings />
                        </Main>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/teams"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <TeamsIndex />
                            <SetupWizardSnackbar />
                        </Main>
                    </ProtectedRoute>
                }
            >
                <Route path="" element={<Teams />} />
                <Route path=":teamId" element={<TeamIndex />}>
                    <Route path="" element={<Team />} />
                    <Route path="missions-history" element={<MissionsHistoryTeams />} />
                    <Route path="indexes-settings" element={<IndexesSettings />} />
                    <Route
                        path="dashboard"
                        element={
                            <ActiveDateProvider>
                                <TemplateViewEditProvider viewType="teamViews">
                                    <TemplateDrawerProvider>
                                        <TeamDashboard />
                                        <SetupWizardSnackbar />
                                    </TemplateDrawerProvider>
                                </TemplateViewEditProvider>
                            </ActiveDateProvider>
                        }
                    >
                        <Route path="overview" element={<Navigate to="/navigation" replace />} />
                        <Route path="insights" element={<TeamInsights />} />
                        <Route path=":dashboardId" element={<TeamAnalytics />} />
                        <Route index element={<RedirectToInsights />} />
                    </Route>
                </Route>
            </Route>
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <ActiveDateProvider>
                                <TemplateViewEditProvider viewType="personalViews">
                                    <TemplateDrawerProvider>
                                        <Dashboard />
                                        <SetupWizardSnackbar />
                                    </TemplateDrawerProvider>
                                </TemplateViewEditProvider>
                            </ActiveDateProvider>
                        </Main>
                    </ProtectedRoute>
                }
            >
                <Route path="insights" element={<Insights />} />
                <Route path=":dashboardId" element={<Analytics />} />
                <Route index element={<Navigate to="/dashboard/insights" replace />} />
            </Route>
            <Route
                path="/error"
                element={
                    <>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <Error />
                        </Main>
                    </>
                }
            />
            <Route path="/dashboard/overview" element={<Navigate to="/navigation" replace />} />
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <Navigate to="/navigation" />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/*"
                element={
                    <>
                        <Header handleSetDark={handleSetDark} />
                        <Main>
                            <NotFound />
                        </Main>
                    </>
                }
            />
        </RouterRoutes>
    );
};

export default Routes;
